import React from "react";
import keycloak from "../APIs/keycloak";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import BoardCertificationTab from "./BoardCertification";
import SpecialtyTab from "./SpecialtyTab";
import UniversityList from "./UniversityList";
import InsurancePlanTab from "./InsurancePlanTab";
import ProviderVerificationQueue from "./ProviderVerificationQueue";

export default function AdminTabs() {
  const handleLogout = () => {
    keycloak.logout({
      redirectUri: process.env.REACT_APP_SITE_URL || window.location.origin,
    });
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-6 flex items-start justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold mb-2">Admin</h1>
          <p className="text-sm text-gray-500">
            Providers · Verification Requests · Documents · Audit Log
          </p>
        </div>
        <button
          type="button"
          onClick={handleLogout}
          className="rounded border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Logout
        </button>
      </div>

      <Tabs>
        <TabList className="flex border-b mb-4">
          <Tab
            className="px-4 py-2 cursor-pointer"
            selectedClassName="border-b-2 border-blue-600 font-semibold"
          >
            Verification Requests
          </Tab>
          <Tab
            className="px-4 py-2 cursor-pointer"
            selectedClassName="border-b-2 border-blue-600 font-semibold"
          >
            Board Certifications
          </Tab>
          <Tab
            className="px-4 py-2 cursor-pointer"
            selectedClassName="border-b-2 border-blue-600 font-semibold"
          >
            Insurance
          </Tab>
          <Tab
            className="px-4 py-2 cursor-pointer"
            selectedClassName="border-b-2 border-blue-600 font-semibold"
          >
            Universities
          </Tab>
          <Tab
            className="px-4 py-2 cursor-pointer"
            selectedClassName="border-b-2 border-blue-600 font-semibold"
          >
            Specialties
          </Tab>
        </TabList>

        <TabPanel>
          <ProviderVerificationQueue />
        </TabPanel>
        <TabPanel>
          <BoardCertificationTab />
        </TabPanel>
        <TabPanel>
          <InsurancePlanTab />
        </TabPanel>
        <TabPanel>
          <UniversityList />
        </TabPanel>
        <TabPanel>
          <SpecialtyTab />
        </TabPanel>
      </Tabs>
    </div>
  );
}
